import React from "react";

import { useIntl } from "react-intl";

import { EntityType } from "@mapmycustomers/shared";
import { EntityTypesSupportingFieldCustomization } from "@mapmycustomers/shared/types/entity";
import { Alert } from "@mapmycustomers/ui";

import FileUploader from "@app/component/FileUploader";

interface Props {
  disabled?: boolean;
  entityType: EntityTypesSupportingFieldCustomization;
  required?: boolean;
}

const File: React.FC<Props> = ({ disabled, entityType, required }) => {
  const intl = useIntl();

  const dummyHandle = () => {
    // No action needed here
  };

  return (
    <div>
      <FileUploader
        disabled={disabled}
        onFileUpload={dummyHandle}
        onRemoveFile={dummyHandle}
        required={required}
      />
      {entityType !== EntityType.ACTIVITY && (
        <Alert
          message={intl.formatMessage({
            id: "settings.formLayouts.canvas.files.alert",
            defaultMessage:
              "File uploader will only show upon creation of a record. Once created, files are managed via the Files tab.",
            description: "Alert for the File field in Layout constructor",
          })}
          showIcon
          type="info"
        />
      )}
    </div>
  );
};

export default File;
